export default __webpack_public_path__ + "static/ForeverEssential-PrimaryLogo-110da0a8413e09e53b910da70eb330e1.png";